export default __webpack_public_path__ + "static/media/graduate-small-icon.03de7c28.svg";